const predefinedDateFormats = {
  Full: {name: 'medium'}, // en-US example: 2/13/2011
  DayOfMonth: {pattern: 'd'},  // 13
  DayName: {skeleton: 'EEEE'}, // Sunday
  ShortDayName: {skeleton: 'EEE'}, // Sun
  NarrowDayName: {pattern: 'EEEEE'}, // S
  MonthName: {skeleton: 'MMMM'}, // February
  ShortMonthName: {skeleton: 'MMM'}, // Feb
  LongDateWeekDay: 'D' // en-US example: Sunday, February 13, 2011
};

const predefinedTimeFormats = {
  '24H': {skeleton: 'HHmm'}, // en-US example: 23:33 (default time format)
  Auto: 't' // for en-US "10:30 PM" for Israel "22:30"
};

const predefinedDateTimeFormats = { };

const formatExceptions  = { };

export const getPredefinedFormats = (localeId) => {
  const localeExceptions = formatExceptions[localeId];
  return {...predefinedDateTimeFormats, ...predefinedDateFormats, ...predefinedTimeFormats, ...localeExceptions};
};

